import { configureStore } from '@reduxjs/toolkit';
import authUserReducer from './AuthUserSlice';
import snackbarReducer from './SnackbarSlice';


const store = configureStore({
    reducer: {
        authUser: authUserReducer,
        snackbar: snackbarReducer
    }
})

export default store;
